// extracted by mini-css-extract-plugin
export var root = "M_xb";
export var wrapper = "M_xc";
export var image = "M_xd d_w d_y d_W";
export var imageWithHeight = "M_xf";
export var crop = "M_xg";
export var round = "M_xh";
export var fixedHeight = "M_xj";